import React, { Component } from 'react';
import moment from 'moment';
import GeoMap from '../GeoMap/GeoMap';
import Breadcrumb from '../UI/Breadcrumb';
import PageTitle from '../UI/PageTitle';
import { breadcrumbs } from "../../utils/constants";
import { connect } from "react-redux";
import { getOrder } from "../../store/actions";


const OrderInfoRow = props => (
    <li className="py-15">
        <p className="font-sm color-grey50">{ props.label }</p>
        <p className="color-primary mt-5">{ props.value }</p>
    </li>

);


class Order extends Component {

    componentDidMount() {
        const orderId = this.props.match.params.id;
        this.props.getOrder(orderId);
    }

    render() {
        const { order } = this.props;
        if (!order)  return null;
        const time = moment(new Date(order.created)).format("hh:mm");
        return (
            <React.Fragment>
                <PageTitle title="Single Order"/>

                <div className="container">
                    <Breadcrumb from={ breadcrumbs.order } current="Single Order"/>
                </div>

                <div className="container box inner-padding mb-15">
                    <div className="box-body">
                        <div className="row justify-between">
                            <div className="col-xs-6 pr-70">
                                <ul className="w-700">
                                    <OrderInfoRow label="Order ID" value={ order.id }/>
                                    <OrderInfoRow label="Order App Initiator" value={ order.initiator }/>

                                    <li className="py-15">
                                        <p className="font-sm color-grey50">Order Date/Time</p>
                                        <p className="color-primary mt-5"><span className="mr-15">{ moment(order.created).format('YYYY-MM-DD') }</span><span>{time}</span></p>
                                    </li>
                                    <li className="py-15">
                                        <p className="font-sm color-grey50">Order Details</p>
                                        <ul className="tags mt-5">
                                            {
                                                order.order_items.map(item => {
                                                    return (
                                                        <li key={item.id}>
                                                            <span>{item.item_name} </span><span className="divider"></span><span className="w-700 color-grey50">{item.item_count} pcs</span>
                                                        </li>
                                                    );
                                                })
                                            }
                                        </ul>
                                    </li>
                                    <li className="py-15">
                                        <p className="font-sm color-grey50">Total Order Cost</p>
                                        <p className="color-primary mt-5"><span>{order.order_sum}</span> SAR</p>
                                    </li>
                                    <li className="py-15">
                                        <p className="font-sm color-grey50">Delivery Fees</p>
                                        <p className="color-primary mt-5"><span>{ order.delivery_fee }</span> SAR</p>
                                    </li>

                                    <OrderInfoRow label="Defined Delivery Time" value={ order.delivery_time } />

                                    <li className="py-15">
                                        <p className="font-sm color-grey50">Pick-up restaurant name</p>
                                        <p className="color-primary mt-5"><span> { order.restaurant_name }</span></p>
                                    </li>

                                    <OrderInfoRow label="Pick-up restaurant address" value={ order.restaurant_address }/>

                                </ul>
                            </div>
                            <div className="col-xs-6 pl-70">
                                <ul className="w-700">
                                    <li className="py-15">
                                        <p className="font-sm color-grey50">Pick-up restaurant phone number</p>
                                        <p className="color-primary mt-5"><span>{ order.restaurant_phone_number }</span></p>
                                    </li>
                                    <li className="py-15">
                                        <p className="font-sm color-grey50">Requester Name</p>
                                        <p className="color-primary mt-5"><span>{ order.requester_name }</span></p>
                                    </li>
                                    <li className="py-15">
                                        <p className="font-sm color-grey50">Requester mobile number</p>
                                        <p className="color-primary mt-5"><span>{ order.requester_phone_number }</span></p>
                                    </li>
                                    <OrderInfoRow label="Requester Location" value={ order.requester_name}/>
                                    <li>
                                        <GeoMap fixed latLng={{ lat: order.restaurant_position.latitude, lng: order.restaurant_position.longitude }}/>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </React.Fragment>
        );
    }
}

const mapStateToProps = state => {
    return {
        order: state.operations.order
    };
};

export default connect(mapStateToProps, { getOrder })( Order );



// WEBPACK FOOTER //
// ./src/components/Operation-room/Order.js